<template>
    <div class="questions row align-items-center h-100">
        <div class="col align-self-center text-center">
            <transition name="slide-left" mode="out-in">
                <div class="group">
                    <img src="../assets/img/mail.png" srcset="../assets/img/mail@2x.png 2x, ../assets/img/mail@3x.png 3x" height="120px">

                    <div class="question">
                        <div class="d-flex align-items-center justify-content-center text">
                            <div>
                                <h4>Enter your primary email address</h4>
                                <p>We'll be able to send you the report once checked by an SLP.</p>
                            </div>
                        </div>

                        <div class="answer input">
                            <form @submit.prevent="nextStep()">
                                <div class="form-group">
                                    <input type="email" class="form-control form-control-lg" name="email" v-model="email" placeholder="Your email address" required>
                                </div>
                                <button type="submit" class="btn btn-purple btn-lg">Continue</button>
                            </form>
                        </div>
                    </div>
                </div>
            </transition>
        </div>
    </div>
</template>

<script>
export default {
  name: 'screener-email',

  data () {
    return {
      email: ''
    }
  },

  methods: {
    nextStep () {
      if (!this.validateEmail(this.email)) {
        return
      }
      this.$root.$emit('email_entered', this.email)
      window.dataLayer = window.dataLayer || []
      window.dataLayer.push({
        'event': 'gtm-screener-enter-email'
      })
      this.$router.push('/screener/basics/name')
    },
    validateEmail (email) {
      var re = /^(([^<>()\[\]\.,;:\s@\"]+(\.[^<>()\[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i
      return re.test(email)
    }
  }
}
</script>

<style lang="less" scoped>
.questions {
  .col {
    margin: auto;
  }

  .group {
    padding: 40px 0;
  }

  .group-title {
    color: #5dd1aa;
    font-size: 18px;
    margin: 30px 0 0;
    text-transform: uppercase;
  }

  .question {
    .text {
      min-height: 160px;

      h4 {
        font-size: 20px;
        font-weight: 700;
        margin: 10px 0 10px;
      }

      p {
        margin: 20px 0 10px;
      }
    }

    .answer {
      &.input {
        .form-control, .btn, .vdp-datepicker {
          margin: 0 auto;
          max-width: 300px;
          width: 100%;
        }
      }

      &.buttons {
        span {
          color: #3c32a0;
          cursor: pointer;
        }

        span:nth-child(-n+2) {
          border: 2px #3c32a0 solid;
          border-radius: 50%;
          display: inline-block;
          height: 90px;
          line-height: 86px;
          margin: 10px;
          width: 90px;

          #app:not(.touch) &:hover, &:focus, &:active, &.selected {
            background: #3c32a0;
            color: #fff;
            transition: background 0.2s, color 0.2s;
          }
        }

        span:nth-child(3) {
          display: block;
          margin: 30px 0 0;
        }
      }
    }
  }

  .loading {
    h4 {
      margin: 30px 0 0;
    }
  }
}
</style>
